import React from "react";
import { useNavigate } from "react-router-dom";

import { ZoneAvatar } from "@common/zoneAvatar";
import { ProjectModelsIcon } from "@common/assets/projectModelsIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Parent({ project }: Props) {
  const push = useNavigate();

  return !project.isTemplate ? (
    <div
      className={styles.parent}
      onClick={() => push(`/zones/${project.zone.uuid}/projects`)}
    >
      <div className={styles.icon}>
        <ZoneAvatar {...project.zone} />
      </div>
    </div>
  ) : (
    <div
      className={styles.parent}
      onClick={() => push("/utilities/project-models")}
    >
      <div className={styles.icon}>
        <ProjectModelsIcon className={styles.projectModelsIcon} />
      </div>
    </div>
  );
}

export { Parent };
